export default __webpack_public_path__ + "static/media/cryptocurrency.352f7eba.png";